import { defineComponent, openBlock, createElementBlock, Fragment, createVNode, unref, createElementVNode, normalizeClass, withCtx } from "vue";
import { CdrContainer } from "@rei/cedar";
import _sfc_main$1 from "../VisibilityTracker/VisibilityTracker.mjs";
import _sfc_main$2 from "./CoopBrandCertifications/CoopBrandCertifications.mjs";
import CoopImgAsset from "./CoopImgAsset/CoopImgAsset.mjs";
const _hoisted_1 = {
  class: "coop-brand-asset"
};
const _hoisted_2 = {
  class: "coop-brand-asset__text-area"
};
const _hoisted_3 = {
  class: "coop-brand-asset__media"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CoopBrandAsset",
  props: {
    assets: {},
    showXlBreakpoint: {
      type: Boolean
    }
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [createVNode(unref(_sfc_main$1), {
        "link-name": "coop_asset_impression",
        onMetricsClick: _cache[0] || (_cache[0] = (data) => _ctx.$emit("metricsClick", data))
      }), createElementVNode("section", _hoisted_1, [createVNode(unref(CdrContainer), {
        "data-ui": "coop-brand-asset",
        class: normalizeClass(["coop-brand-asset__container", {
          "coop-brand-asset__container--xl": _ctx.showXlBreakpoint
        }])
      }, {
        default: withCtx(() => [createElementVNode("div", {
          class: normalizeClass(["coop-brand-asset__bg-overlay", {
            "coop-brand-asset__bg-overlay--xl": _ctx.showXlBreakpoint
          }])
        }, null, 2), createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = createElementVNode("svg", {
          class: "logo__img",
          xmlns: "http://www.w3.org/2000/svg",
          width: "120",
          height: "71",
          viewBox: "0 0 158 100",
          fill: "white"
        }, [createElementVNode("title", null, "REI Co-op"), createElementVNode("desc", null, "REI co-op logo"), createElementVNode("g", {
          "fill-rule": "evenodd"
        }, [createElementVNode("path", {
          d: "M128.3 80.3H116A4.6 4.6 0 0 0 111 85v4.7a4.6 4.6 0 0 0 4.7 4.6h12.3a4.6\n              4.6 0 0 0 4.6-4.6V85a4.6\n             4.6 0 0 0-4.7-4.7zm.4 9.4a.4.4 0 0 1-.4.4H116a.4.4 0 0\n             1-.6-.3V85c0-.3.2-.4.5-.4h12.3c.2 0 .4\n             0 .4.4v4.7zm-21-5c-.2-.2-.4-.2-.5 0l-1.4 2.3a.6.6 0 0 0\n             0 .6l1.4 2.4h.4l1.4-2.4a.6.6\n             0 0 0 0-.6l-1.4-2.3m45-4.4h-17.2V100h4.2v-5.7h13a4.6 4.6 0 0\n             0 4.5-4.6V85a4.6 4.6 0 0 0-4.5-4.7zm.3 9.4a.4.4 0\n             0 1-.5.4h-13v-5.4h13c.2 0 .4 0 .4.4v4.7zM142.3 76h11.8a3 3 0 0\n             0 3-2.8V37.7h-14.8V76m-83 9v4.7a4.6 4.6 0 0 0\n             4.7 4.6h15.3V90H64a.4.4 0 0 1-.3-.3V85c0-.3\n             0-.4.4-.4h15.3v-4.3H64a4.6 4.6 0 0 0-4.6\n             4.7m49-9h28v-8H120v-7h16.4v-8.2H120v-7h16.4v-8h-31V73a3 3 0 0 0 3 3"
        }), createElementVNode("path", {
          d: "M59.4 49.7V76h14.8V66h4.5l7 10H102l-8.4-12.4 5.8-5.8v-20H84.7L74.2\n                43v-3.8c0-.8-.7-1.5-1.6-1.5h-4L91.5\n                7 119 31.5l14-15.3 18 15.3h6L133 10.3 117 23.6 93.4\n                3l-3-2.8L41 49.4l-5.7-11.7H40L25.5 10.3\n                11.3 37.7h4.5L6.2 57h6L1 80.2l53.2 14-10.5-23.7\n                15.7-21zm14.8 1.7L84.7 46v11H74.2v-5.6z"
        }), createElementVNode("path", {
          d: "M99 80.3H86.4A4.6 4.6 0 0 0 82 85v4.7a4.6 4.6 0\n                0 0 4.5 4.6H99a4.6 4.6 0 0 0 4.5-4.6V85a4.6 4.6\n                0 0 0-4.6-4.7zm.3 9.4a.4.4 0 0 1-.4.4H86.4a.4.4\n                0 0 1-.4-.3V85c0-.3.3-.4.5-.4H99s.3 0 .3.4v4.7z"
        })])], -1)), _cache[3] || (_cache[3] = createElementVNode("h2", {
          class: "coop-brand-asset__header"
        }, " Better gear is built together ", -1)), _cache[4] || (_cache[4] = createElementVNode("p", null, " From feedback to field testing, all of our gear is dialed-in by REI Co-op members. Their adventures informed every stitch and detail—making for better, longer-lasting gear. ", -1)), createVNode(unref(_sfc_main$2), {
          class: "coop-brand-asset__certifications coop-brand-asset__certifications--desktop"
        })]), createElementVNode("div", _hoisted_3, [createVNode(unref(CoopImgAsset), {
          assets: _ctx.assets,
          "show-xl-breakpoint": _ctx.showXlBreakpoint,
          onMetricsClick: _cache[1] || (_cache[1] = (data) => emit("metricsClick", data))
        }, null, 8, ["assets", "show-xl-breakpoint"])]), createVNode(unref(_sfc_main$2), {
          class: "coop-brand-asset__certifications coop-brand-asset__certifications--mobile"
        })]),
        _: 1
      }, 8, ["class"])])], 64);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=CoopBrandAsset2.mjs.map
